export const ENABLE_POPUP = 'enablePopup';
